<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title
          >Gestión de Consultorios y Salas de Espera</v-toolbar-title
        >
      </v-toolbar>
      <v-expansion-panels v-model="state" accordion class="mt-3">
        <v-expansion-panel>
          <v-expansion-panel-header>Consultorios</v-expansion-panel-header>
          <v-expansion-panel-content>
            <Consultorios />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Salas de Espera</v-expansion-panel-header>
          <v-expansion-panel-content>
            <SalasEspera />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="salir">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import Consultorios from "./Consultorios.vue";
import SalasEspera from "./SalasEspera.vue";
import router from "../../router/index.js";

export default {
  data() {
    return {
      state: null,
    };
  },
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },
  },
  components: {
    Consultorios,
    SalasEspera,
  },
};
</script>
